import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';
import { SettingsComponent } from './settings.component';
import { SharedNotificationService } from '../shared/services/shared-notification.service';
import { ClientRouteResolve } from '../../../providers/client-route-resolve.service';
import { routing } from './settings.routing';


export class SettingsModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/settings/settings.module.ts